import { postQRCodeLoginAuthorize } from "@/apis/common";
import { LINK_ACCOUNT_TOKEN } from "@/constants";
import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { useUserInfoStore } from "@/stores/userInfo";
import { useRequest } from "ahooks";
import { Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";
/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {
  password: string;
}

const pagestate = {
  password: "",
};

type ActionType = "update-password";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-password":
      return Object.assign({}, state, {
        password: action.password,
      });

    default:
      return state;
  }
};

export const useSetup = () => {
  const navigate = useNavigate();
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {}
  );

  const reqConfirm = useRequest(
    async () => {
      const r = await postQRCodeLoginAuthorize({
        authToken: window.localStorage[LINK_ACCOUNT_TOKEN] as string,
        securePassword: state.password,
      });
      if (r.ok) {
        window.localStorage.removeItem(LINK_ACCOUNT_TOKEN)
        navigate("/", { replace: true });
      } else {
        Toast.show(r.msg);
      }
    },
    {
      manual: true,
      onError: (e) => {
        Toast.show({
          content: e.message,
        });
      },
    }
  );

  const cleanToken = () => {
    window.localStorage.removeItem(LINK_ACCOUNT_TOKEN)
    navigate("/");
  };

  return { state, dispatch, navigate, reqConfirm, cleanToken, userInfo };
};
